import React, { useState, useEffect } from 'react';
import placeholderImage from './assets/placeholder.png';

const ImageCarousel = ({ images = [] }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  useEffect(() => {
    if (images.length > 1) {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => 
          prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [images]);

  return (
    <div className="relative h-full">
      <img
        src={images.length > 0 ? images[currentImageIndex] : placeholderImage}
        alt="Carousel"
        className="w-full h-full object-contain"
      />
    </div>
  );
};

export default ImageCarousel;
